module.exports = __webpack_public_path__ + "static/media/Plan1.15f03986.png";